import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { useAsObservableSource } from 'mobx-react-lite';

export interface PropsType {
    onCreate: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    onUpdate: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    onCancel: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    isEditMode: boolean,
    isCreateDisabled?: boolean,
    isUpdateDisabled?: boolean,
    isCancelDisabled?: boolean,
    createIcon?: JSX.Element,
    updateIcon?: JSX.Element,
    cancelIcon?: JSX.Element,
    dataTestCreate?: string,
    dataTestUpdate?: string,
    dataTestCancel?: string,
}

export const FormButtons = observer('Button', (propsIn: PropsType) => {
    const props = useAsObservableSource(propsIn);

    const {
        onCreate,
        onUpdate,
        onCancel,
        isEditMode,
        isCreateDisabled,
        isUpdateDisabled,
        isCancelDisabled,
        createIcon,
        updateIcon,
        cancelIcon,
        dataTestCreate,
        dataTestUpdate,
        dataTestCancel
    } = props;

    return (
        <FormButtonsWrapper>
            <Button version='secondary' isDisabled={isCancelDisabled} onClick={onCancel} dataTest={dataTestCancel}>
                {cancelIcon}
                Cancel
            </Button>
            {isEditMode ?
                <Button isDisabled={isUpdateDisabled} onClick={onUpdate} dataTest={dataTestUpdate}>
                    {updateIcon}
                    Update
                </Button> :
                <Button isDisabled={isCreateDisabled} onClick={onCreate} dataTest={dataTestCreate}>
                    {createIcon}
                    Create
                </Button>
            }
        </FormButtonsWrapper>
    );
});
